import React from "react";
import ApproveMovement from "./ApproveMovement";
import CancelMovement from "./CancelMovement";
import ClaimMovement from "./ClaimMovement";
import CloseMovement from "./CloseMovement";
import DelegateMovement from "./DelegateMovement";
import DisputeMovement from "./DisputeMovement";
import NonDisputeMovement from "./NonDisputeMovement";
import RejectMovement from "./RejectMovement";
import ResubmitMovement from "./ResubmitMovement.tsx";
import UnclaimMovement from "./UnclaimMovement";
import UpdateMovement from "./UpdateMovement";

interface MovementFlowButtonsProps {
  openDrawer: (drawerName: string) => void;
  movementFlowData?: {
    id: string;
    task: {
      taskId: string;
      role: string;
      workflowId: string;
      runId: string;
      status: string;
      claimOwnerName: string;
    } | null;
    status: string;
    submittedByRole?: string | null;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
}

const MovementFlowButtons: React.FC<MovementFlowButtonsProps> = ({
  movementFlowData,
  openDrawer,
}) => {
  return (
    <div className="flex gap-4 mb-4">
      <ClaimMovement movementFlowData={movementFlowData} />
      <UnclaimMovement movementFlowData={movementFlowData} />
      <DelegateMovement movementFlowData={movementFlowData} />
      <RejectMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <UpdateMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <DisputeMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <NonDisputeMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <ApproveMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <CancelMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <CloseMovement movementFlowData={movementFlowData} openDrawer={openDrawer} />
      <ResubmitMovement movementFlowData={movementFlowData} />
    </div>
  );
};

export default MovementFlowButtons;
